import React from "react";
import classNames from "classnames";
import { Text, Icon, IconType, TextProps } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { iconStyle, textStyle } from "./styles_vanilla.css";

export type TextWithIconProps = {
  iconType?: IconType;
  iconColor?: Colors;
  label: string;
  className?: string;
  textVariant?: TextProps["variant"];
};

/**
 * Used to display a text prefix with icon.
 * Eg: (i) Processing, with their respective icons
 */
export const TextWithIcon: React.FC<TextWithIconProps> = (props) => {
  const { className, iconType, label, iconColor = Colors.Neutral800, textVariant } = props;
  return (
    <Text variant={textVariant} className={classNames(textStyle, className)}>
      {iconType && <Icon type={iconType} color={iconColor} className={iconStyle} />}
      {label}
    </Text>
  );
};
